/**
 * Replaces the Liquid fallback cards with the selected collection's products
 * in Shopify's native best-selling order.
 */
(function () {
  'use strict';

  if (customElements.get('pg-cart-bestsellers')) return;

  class PgCartBestsellers extends HTMLElement {
    connectedCallback() {
      this.requestNumber = 0;
      this.latestCartVersion = 0;
      this.onCartUpdated = this.handleCartUpdated.bind(this);
      document.addEventListener('pg:cart-updated', this.onCartUpdated);
      this.load();
    }

    disconnectedCallback() {
      document.removeEventListener('pg:cart-updated', this.onCartUpdated);
      if (this.controller) this.controller.abort();
    }

    handleCartUpdated(event) {
      var detail = event.detail || {};
      var cart = detail.cart || detail;
      var version = Number(detail.version) || 0;
      if (!cart || !Array.isArray(cart.items) || typeof cart.item_count !== 'number' || typeof cart.total_price !== 'number') return;
      if ((!version && this.latestCartVersion) || (version && version < this.latestCartVersion)) return;
      if (version) this.latestCartVersion = version;
      var ids = cart.items.map(function (item) { return String(item.product_id); });
      this.dataset.cartProductIds = ids.join(',');
      this.load();
    }

    cartProductIds() {
      return new Set(
        (this.dataset.cartProductIds || '')
          .split(',')
          .map(function (id) { return id.trim(); })
          .filter(Boolean)
      );
    }

    load() {
      var sourceUrl = this.dataset.sourceUrl;
      var grid = this.querySelector('[data-pg-bestseller-grid]');
      var limit = parseInt(this.dataset.productsToShow, 10) || 4;
      if (!sourceUrl || !grid) return;

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      var signal = this.controller.signal;
      var requestNumber = ++this.requestNumber;
      var cartIds = this.cartProductIds();

      fetch(sourceUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Bestseller konnten nicht geladen werden.');
          return response.text();
        })
        .then(function (html) {
          if (requestNumber !== this.requestNumber) return;

          var documentFragment = new DOMParser().parseFromString(html, 'text/html');
          var candidates = Array.from(
            documentFragment.querySelectorAll('[data-pg-bestseller-feed] .pg-card[data-product-id]')
          );
          var products = candidates
            .filter(function (card) {
              return card.dataset.productAvailable !== 'false' && !cartIds.has(card.dataset.productId);
            })
            .slice(0, limit);

          grid.replaceChildren.apply(grid, products);
          this.hidden = products.length === 0;
          document.dispatchEvent(new CustomEvent('pg:cards-updated'));
        }.bind(this))
        .catch(function (error) {
          if (error.name !== 'AbortError') {
            // Keep the server-rendered fallback cards if the request fails.
          }
        });
    }
  }

  customElements.define('pg-cart-bestsellers', PgCartBestsellers);
})();
